import { create } from 'zustand';

interface APIKeyStoreState {
  apiKeyId: string | null;
  token: string | null;
  stash: (apiKeyId: string, token: string) => void;
  consume: (apiKeyId: string) => string | null;
}

/** Hands a created API key's token to that key's page. Never persist: a reload must lose it. */
export const useAPIKeyStore = create<APIKeyStoreState>((set, get) => ({
  apiKeyId: null,
  token: null,

  stash: (apiKeyId, token) => set({ apiKeyId, token }),

  consume: (apiKeyId) => {
    const { apiKeyId: stashedID, token } = get();
    if (!token || stashedID !== apiKeyId) {
      return null;
    }
    set({ apiKeyId: null, token: null });
    return token;
  },
}));
